import { useId, useRef } from 'react';
import './fileUpload.css';

export const AdminFileUpload = ({
  id,
  label = 'Image',
  accept = 'image/*',
  fileName = '',
  onChange,
}) => {
  const autoId = useId();
  const inputId = id || autoId;
  const inputRef = useRef(null);

  const openPicker = () => {
    inputRef.current?.click();
  };

  return (
    <div className="admin-file-upload">
      {label ? <span className="admin-file-upload__label">{label}</span> : null}
      <div className="admin-file-upload__box">
        <input
          ref={inputRef}
          id={inputId}
          type="file"
          className="admin-file-upload__input"
          accept={accept}
          onChange={onChange}
        />
        <button
          type="button"
          className="admin-file-upload__btn"
          onClick={openPicker}
        >
          Choose file
        </button>
        <span className="admin-file-upload__name" title={fileName || undefined}>
          {fileName || 'No file chosen'}
        </span>
      </div>
    </div>
  );
};
